package com.essntl.features.proposal.ui.addeditproposal

import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.proposal.ui.selectservice.SelectServiceNavigation
import com.essntl.features.service.domain.model.service.ServiceModel

sealed interface AddEditProposalNavigation {
    data object Back : AddEditProposalNavigation

    data object ClosePanel : AddEditProposalNavigation

    data class OpenProposalPreview(val preview: String) : AddEditProposalNavigation

    data class EditService(
        val service: ServiceModel,
        val enableEdit: Boolean,
    ) : AddEditProposalNavigation

    data class NavigateToItinerary(
        val itineraryId: String,
    ) : AddEditProposalNavigation

    data object AddClient : AddEditProposalNavigation

    data object SelectClient : AddEditProposalNavigation

    data class EditClient(val client: ClientModel) : AddEditProposalNavigation

    data object Invoicing : AddEditProposalNavigation

    data class EditInvoicing(
        val invoiceId: String,
        val proposalId: String,
    ) : AddEditProposalNavigation

    data object AddTravelAgent : AddEditProposalNavigation

    data class SetPrice(val proposalService: ProposalServiceModel) : AddEditProposalNavigation

    data object AddProposalTask : AddEditProposalNavigation

    data class EditTask(val taskId: String) : AddEditProposalNavigation
}